import * as variables from './variables.js';
import * as $ from 'jquery';

import 'window.requestanimationframe';
import JSFAjaxJQueryAdapter from '@plaudit/jsf-ajax-adapters/dist/jQuery';
JSFAjaxJQueryAdapter.init();

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import Forms from './component/Forms';
Forms.init();

import MainMenu from './component/MainMenu';
new MainMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	//hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});

import Gallery from './component/Gallery';
new Gallery();

/* --- Form Enhancements --- */
// @ts-ignore
import * as Dropkick from './site/dropkick.js';
Dropkick.init();

// @ts-ignore
import * as Contact from './site/contact.js';
Contact.init();

import ArticleListing from './site/ArticleListing';
new ArticleListing();

/* --- Map --- */
// @ts-ignore
import * as PropertyListing from './site/propertyListing.js';
PropertyListing.init();

// @ts-ignore
import * as TabbedArea from './site/TabbedArea.js';
TabbedArea.init();

/* --- Misc --- */
// @ts-ignore
import * as Stories from './site/Stories.js';
Stories.init();

// @ts-ignore
import * as propertyCarousel from './site/propertyCarousel.js';
propertyCarousel.init();

// @ts-ignore
// import * as newsletterSignup from './site/newsletterSignup.js';
// newsletterSignup.init();

import SiteAnimations from './component/SiteAnimations';
new SiteAnimations();

// @ts-ignore
import * as lightboxMessage from './site/lightboxMessage.js';
lightboxMessage.init();

// Google Review List
import './component/Reviews';